import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
import { formatRP, getUser } from "../../../Utils/externalFunctions";
import useAxios from "../../../Utils/useAxios";
import FilterComponent from "../../FilterComponents/FilterComponent";
import { SumberDanaConstant } from "../../../Constant/SumberDanaConstant";
import { filterSearch, filterSumberDana } from "../../../Utils/FilterItems";
import { Link } from "react-router-dom";
import ModalSimple from "./ModalSimple";
import { Info } from "react-feather";
import { admins } from "../../../Constant";
import ModalEdit from "./ModalEdit";
import { useThemeContext } from "../../../Context/ThemeContext";
import {
  getDarkDropdown,
  getDarkTableRow,
} from "../../../Utils/otherFunctions";
import RincianAnggaranColumns from "../contants/RincianAnggaranColumns";
import getRencImp from "../services/getRencImp";

function ModalRIB({ modal, toggle, selectedAnggaran }) {
  const axiosInstance = useAxios();

  const [rencanaImpList, setRencanaImpList] = useState([]);
  const [pending, setPending] = useState(false);

  const [selectedRencimp, setSelectedRencimp] = useState([]);
  const [selectedSumberDana, setSelectedSumberDana] = useState(0);
  const [totalAnggaran, setTotalAnggaran] = useState({});
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const [modalDetailOpen, setModalDetailOpen] = useState(false);
  const toggleModalDetail = () => setModalDetailOpen(!modalDetailOpen);

  const { themeContext } = useThemeContext();

  useEffect(() => {
    const rencImp = filterAnggaranItems(rencanaImpList);
    calculateTotalAnggaran(rencImp);
  }, [selectedAnggaran, selectedSumberDana, filterText]);

  useEffect(() => {
    const updateData = async () => {
      if (selectedAnggaran.pk) {
        refreshRencanaImp(selectedAnggaran.pk);
      }
    };

    updateData();
  }, [selectedAnggaran]);

  const refreshRencanaImp = async (pk) => {
    setPending(true);
    getRencImp(axiosInstance, pk).then((res) => {
      calculateTotalAnggaran(res.data);
      setRencanaImpList(res.data);
      setPending(false);
    });
  };

  const calculateTotalAnggaran = (rencImp) => {
    let anggaranAwal = 0;
    let anggaranTersisa = 0;
    if (rencImp) {
      rencImp.map((item) => {
        if (
          Number(selectedSumberDana) === 0 ||
          item.id_sumber_dana === Number(selectedSumberDana)
        ) {
          anggaranAwal += parseFloat(item.anggaran);
          anggaranTersisa += parseFloat(item.anggaran_tersisa);
        }
      });
      setTotalAnggaran({
        anggaran_awal: formatRP(anggaranAwal),
        anggaran_realisasi: formatRP(anggaranAwal - anggaranTersisa),
        anggaran_tersisa: formatRP(anggaranTersisa),
      });
    } else {
      setTotalAnggaran({
        anggaran_awal: formatRP("0.00"),
        anggaran_realisasi: formatRP("0.00"),
        anggaran_tersisa: formatRP("0.00"),
      });
    }
  };

  const filterAnggaranItems = (items) => {
    const searchCategories = [
      "pk",
      "nm_org",
      "anggaran",
      "anggaran_tersisa",
      "nm_akun",
      "kd_akun",
      "nm_keg",
      "kd_keg",
      "kode_jk",
    ];
    const filteredItems = items
      .filter(filterRencImp)
      .filter(filterSumberDana("id_sumber_dana", selectedSumberDana))
      .filter(filterSearch(searchCategories, filterText));

    return filteredItems;
  };
  const filterRencImp = (item) =>
    item.id_anggaran_bulanan_unit_kerja === selectedAnggaran.pk;

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <>
      <Modal isOpen={modal} toggle={toggle} size="xl" scrollable={true}>
        <ModalHeader toggle={toggle}>Rincian Anggaran</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={5}>
              <table className="table">
                <tbody>
                  <tr>
                    <th scope="row" className={getDarkTableRow(themeContext)}>
                      <strong>Anggaran Awal</strong>
                    </th>
                    <td className={"w-50" + getDarkTableRow(themeContext)}>
                      Rp.{" "}
                      {totalAnggaran.anggaran_awal
                        ? formatRP(totalAnggaran.anggaran_awal)
                        : formatRP(selectedAnggaran.total_anggaran)}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" className={getDarkTableRow(themeContext)}>
                      <strong>Anggaran Realisasi</strong>
                    </th>
                    <td className={getDarkTableRow(themeContext)}>
                      Rp.{" "}
                      {totalAnggaran.anggaran_realisasi
                        ? formatRP(totalAnggaran.anggaran_realisasi)
                        : formatRP(selectedAnggaran.total_terpakai)}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" className={getDarkTableRow(themeContext)}>
                      <strong>Anggaran Tersisa</strong>
                    </th>
                    <td className={getDarkTableRow(themeContext)}>
                      Rp.{" "}
                      {totalAnggaran.anggaran_tersisa
                        ? formatRP(totalAnggaran.anggaran_tersisa)
                        : formatRP(selectedAnggaran.total_sisa)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>

          <div className="text-center p-20">
            <Row className="align-items-center">
              <strong className="col-2">Sumber Dana</strong>
              <select
                aria-label="unitkerja"
                name="id_unit_kerja"
                className={
                  "form-control form-select w-100 col" +
                  getDarkDropdown(themeContext)
                }
                onChange={(e) => setSelectedSumberDana(e.target.value)}
              >
                <option value={0}>Semua</option>
                {SumberDanaConstant.map((sumber) => (
                  <option key={sumber.pk} value={sumber.pk}>
                    {sumber.nama_sumber_dana}
                  </option>
                ))}
              </select>
            </Row>
          </div>
          <DataTable
            columns={RincianAnggaranColumns(
              setSelectedRencimp,
              toggleModalDetail,
              refreshRencanaImp,
              selectedAnggaran
            )}
            data={filterAnggaranItems(rencanaImpList)}
            pagination
            dense
            highlightOnHover
            persistTableHead
            subHeader
            paginationResetDefaultPage={resetPaginationToggle}
            subHeaderComponent={
              <FilterComponent
                onFilter={(e) => {
                  let newFilterText = e.target.value;
                  setFilterText(newFilterText);
                }}
                onClear={() => handleClear()}
                filterText={filterText}
              />
            }
            subHeaderAlign="right"
            progressPending={pending}
            theme={themeContext}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
        <ModalSimple
          selectedRencimp={selectedRencimp}
          modal={modalDetailOpen}
          toggle={toggleModalDetail}
        />
      </Modal>
    </>
  );
}

export default ModalRIB;
